import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    LogActivity as LogActivityMutation,
    LogActivityVariables as LogActivityMutationVariables,
    LogActivityInput,
} from 'nutshell-graphql-types';

import LOG_ACTIVITY from '../mutations/log-activity.graphql';

export function useLogActivity(): {
    logActivity: (arg1: LogActivityInput) => Promise<any>;
    error: string | null | undefined;
    isLoading: boolean;
} {
    const [logActivity, {error, loading}] = useMutation<
        LogActivityMutation,
        LogActivityMutationVariables
    >(LOG_ACTIVITY);

    return {
        logActivity: (input: LogActivityInput) =>
            logActivity({
                variables: {
                    input,
                },
                refetchQueries: ['GetExternalMeetings', 'GetMeetingsSidebarCounts'],
            }),
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
    };
}
